import React, { Component, Fragment } from 'react';
import { convertToRupiah, copyText } from '../../../config/utils';
import { getUser } from '../../../services/api-services/krs-api';
import { getTagihan } from '../../../services/api-services/pembayaran';
// import TestingVA from './testingVA';
import VirtualAccount from './VirtualAccount';

export const LOGO_VA = (bank) => {
  switch (bank) {
    case 'BNI':
      return <img className='mr-2' src='https://upload.wikimedia.org/wikipedia/id/thumb/5/55/BNI_logo.svg/1200px-BNI_logo.svg.png' alt="" width='auto' height={15} />
    case 'MANDIRI':
      return <img className='mr-2' src='https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Bank_Mandiri_logo_2016.svg/1200px-Bank_Mandiri_logo_2016.svg.png' alt="" width='auto' height={15} />
    default:
      return <img className='mr-2' src='https://ajaib-files.s3.ap-southeast-1.amazonaws.com/bank/deposit_bank-default.png' alt="" width={40} height={40} />
  }
}

class Tagihan extends Component {
  state = {
    listTagihan: [],
    virtualAccount: [],
    user: [],
    isLoading: true,
    isTextCopied: 0,
    jumlahTagihan: 0,
    VAconfig: {
      status: false
    }
  }

  componentDidMount() {
    this.getAllData();
  }

  componentDidUpdate() {
    if (this.state.isTextCopied > 0) {
      setTimeout(() => {
        this.setTextCopied();
      }, 3000);
    }
  } 

  getAllData = async () => {
    const nim = localStorage.getItem('nim');

    const allPromise = Promise.all([
      getUser(nim),
      getTagihan(nim)
    ])

    const promises = await allPromise;

    this.setState({
      user: promises[0].data,
      listTagihan: promises[1].data.rincianbiaya,
      jumlahTagihan: promises[1].data.real_amount,
      virtualAccount: promises[1].data.va,
      isLoading: false
    })
  }

  setTextCopied = (index) => {
    this.setState({
      isTextCopied: index === null ? 0 : index
    })
  }

  toggleVA = (val) => {
    this.setState({
      VAconfig: {
        ...val,
        status: !this.state.VAconfig.status
      }
    })
  }

  render() {
    const { listTagihan, virtualAccount, isLoading, VAconfig, user, jumlahTagihan } = this.state;
    const isDisplayTagihan = listTagihan.filter((val) => val.semester === `${user.semester}`).length
    const listTagihanSPP = listTagihan.filter(val => val.grup === 'KULIAH' || val.grup === 'DPP')

    const tableAddOns = (val) => {
        return (
            <tr>
                <td className='text-center' colSpan={5}>
                    {
                        val === 'loading' ?
                            <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                                <div className="dot" />
                                <div className="dot" />
                                <div className="dot" />
                            </div>
                            : '-- Tidak Ada Data --'
                    }
                </td>
            </tr>
        )
    }

    return (
      <Fragment>
        <div className="smooth mb-2">
          <div className="col-md-12 mb-3">
            <div className="row">
              <div className="col-12 col-xl-8 mb-xl-0">
                <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                  Keuangan&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Pembayaran
                </p>
              </div>
            </div>
          </div>
          <div className="card card-custom">
            <div className="card-body">
              <div className='card-group-header'>
                <p className="card-title text-center align-items-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                  Pembayaran
                </p>
                <a 
                  href="https://www.google.com/search?q=cara+melakukan+transfer+va+ke+BNI&rlz=1C5CHFA_enID939ID939&sxsrf=ALiCzsZFE60UJe8QPK4LhCdD5xKWYGDwTQ%3A1669946063156&ei=z1qJY_uSCei44t4Plr2k2AQ&ved=0ahUKEwi7to3v6dn7AhVonNgFHZYeCUsQ4dUDCA8&uact=5&oq=cara+melakukan+transfer+va+ke+BNI&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzIICCEQwwQQoAE6CggAEEcQ1gQQsAM6BwgAELADEEM6BwgjELACECc6BwgAEIAEEA06CAgAEAgQBxAeOggIABAIEB4QDToKCCEQwwQQChCgAToECCEQCjoFCAAQogRKBAhBGABKBAhGGABQqlxY439g94IBaAJwAXgAgAFmiAHBCJIBBDExLjKYAQCgAQHIAQnAAQE&sclient=gws-wiz-serp" 
                  target="_blank"
                  rel="noreferrer noopener"
                  className='btn btn-info'>
                    <span><i className='fa fa-info-circle menu-icon' style={{ fontSize: '1rem' }} /></span>&nbsp;
                    Cara Transfer Bank Melalui VA?
                </a>
              </div>

              <div className="table-responsive pl-2 pr-2">
                <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td>NIM</td>
                      <td> : </td>
                      <td>{user.nim}</td>

                      <td>Angkatan</td>
                      <td> : </td>
                      <td>{user.angkatan}</td>
                    </tr>
                    <tr>
                      <td>Nama</td>
                      <td> : </td>
                      <td>{user.nama}</td>

                      <td>Program Studi</td>
                      <td> : </td>
                      <td>{user.jurusan}</td>
                    </tr>
                    <tr>
                      <td>Tahun Akademik</td>
                      <td> : </td>
                      <td>{user.ta}</td>

                      <td>Semester</td>
                      <td> : </td>
                      <td>{user.semester} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              <br />
                {/* <TestingVA />
              <br />
              <br /> */}
              {/* <div className="table-responsive">
                <span><i className="ti-credit-card menu-icon" /> &nbsp;Virtual Account</span><br /><br />
                <div className='d-flex flex-wrap' style={{ gap: 20 }}>
                  {
                    virtualAccount.map((v, index) => (
                      <div className="mb-4 stretch-card transparent virtual-card" key={index}>
                          <div className={`card ${index % 2 ? 'card-tale' : index % 3 ? 'card-light-green' : 'card-light-danger'}`}>
                              <div className="card-body">
                                  <p className="mb-4 putih h4">{v.bank}</p>
                                  <p className="fs-30 mb-2 putih">{v.nomor_va}
                                    <span onClick={() => copyText(v.nomor_va, () => this.setTextCopied(index + 1))} className='float-right d-flex flex-column align-items-center' style={{ cursor: 'pointer', width: 50 }}>
                                      <i className='far fa-copy' />
                                      <p hidden={isTextCopied === index + 1 ? false : true}>Tersalin!</p>
                                    </span>
                                  </p>
                                  <br />
                                  <p className="putih">Virtual Account {index + 1}</p>
                              </div>
                          </div>
                      </div>
                    ))
                  }
                </div>
              </div>
              <br />
              <br /> */}

              <div className='d-flex column-wrap-responsive'>
                <div className="table-responsive">
                  <span><i className="ti-wallet menu-icon" /> &nbsp;Tagihan & Tanggungan</span><br /><br />
                  <table width="100%" align="center" className="display expandable-table table-bordered table-radius table-striped"
                  >
                    <thead>
                      <tr align="center">
                        <th>Number</th>
                        <th>Rincian Biaya</th>
                        <th>Semester</th>
                        <th>Nominal</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        !isLoading ?
                          listTagihanSPP.length !== 0 ?
                            listTagihanSPP.map((v, index) => (
                                <tr height={10} key={index}>
                                  <td align="center">{index + 1}</td>
                                  <td align="center">{v.namabayar}</td>
                                  <td align="center">{v.semester}</td>
                                  <td align="center">{convertToRupiah(v.hargasatuan)}</td>
                                  <td align="center">{v.status}</td>
                                </tr>
                            ))
                            : <> { tableAddOns('null') } </>
                        : <> { tableAddOns('loading') } </>
                      }
                    </tbody>
                  </table>
                </div>
                <div className='col-md-4'>
                  <br /><br />
                  <div className='d-flex flex-column w-100 TapS rounded-0 shadow-none p-3 tagihan' style={{ whiteSpace: 'normal' }}>
                    <span className='mb-3'>Total tagihan semester ini (SPP / Kuliah)</span>
                    <h3 className='font-weight-bold'>{convertToRupiah(isDisplayTagihan !== 0 ? jumlahTagihan: 0 )}</h3>
                    <i style={{ fontSize: 13, marginTop: 10 }}>*Tagihan hanya berlaku untuk krs semester ini</i>  
                  </div>
                  <br />
                  <span><i className="ti-credit-card menu-icon ml-2" /> &nbsp;Metode Pembayaran VA</span>
                  <br /><br />
                    {
                      virtualAccount.map((v, index) => (
                          <div className="TapS rounded-0 mb-3" onClick={() => this.toggleVA(v)} data-toggle="modal" data-target="#nilai" key={index}>
                            <li className='d-flex justify-content-between align-items-center pr-3 pl-3' style={{ height: 60, cursor: 'pointer' }}>
                              <div className='d-flex align-items-center'>
                                <div className='d-flex justify-content-center bg-light p-2 mr-2' style={{ width: 70, borderRadius: 5 }}>
                                  {LOGO_VA(v.bank)}
                                </div>
                                <span>Bank {v.bank}</span> 
                              </div>
                              <i className='ti-angle-right menu-icon' />
                            </li>
                          </div>
                      ))
                    }
                  <br /><br />
                </div>
              </div>
              <VirtualAccount config={{ ...VAconfig, real_amount: jumlahTagihan, isDisplayTagihan: isDisplayTagihan !== 0 }} toggleShow={this.toggleVA} />
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default Tagihan
